/**
 * Comment interface for the comments table
 */
import { Comment as SupabaseComment } from './supabase';

/**
 * Comment interface representing a comment in the system
 */
export interface IComment {
  /** Unique identifier for the comment */
  id: string;
  
  /** Timestamp when the comment was created */
  created_at: string;
  
  /** User ID of the person who created the comment */
  created_by: string;
  
  /** Content of the comment */
  content: string;
  
  /** ID of the referenced entity (document, forecast, etc.) */
  reference_id: string;
}

/**
 * Comment creation data
 */
export interface ICommentCreate {
  /** Content of the comment */
  content: string;
  
  /** ID of the referenced entity (document, forecast, etc.) */
  reference_id: string;
  
  /** User ID of the person creating the comment */
  created_by: string;
}

/**
 * Comment update data
 */
export interface ICommentUpdate {
  /** ID of the comment to update */
  id: string;
  
  /** New content of the comment */
  content?: string;
}

/**
 * Convert a Supabase Comment to an IComment
 */
export function mapSupabaseCommentToIComment(comment: SupabaseComment): IComment {
  return {
    id: comment.id,
    created_at: comment.created_at,
    created_by: comment.created_by,
    content: comment.content,
    reference_id: comment.reference_id
  };
}